import { createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import * as T from 'utils/types';
import * as API from "app/public_api";

// [{
//   "id": 7,
//   "name": "Beedie School of Business",
//   "department_set": [
//     {
//       "id": 14,
//       "name": "Beedie School of Businss",
//       "short": "BUS",
//       "faculty": 7,
//       "link": "https://beedie.sfu.ca/"
//     }
//   ],
//   "link": "https://beedie.sfu.ca/"
// },...]
const initialState: T.FcltDeptState_static = {
  fclts: {},
  depts: {},
  status: 'idle',
  errorMsg: null
};

const fetchFcltDepts = createAsyncThunk(
  'fcltDepts_static/fetchFcltDepts',
  async ()=>{
    const FcltDepts = await API.getFcltDepts();
    const fclts:T.FcltDicI={}
    const depts:T.DeptDicI={}

    for(let f of FcltDepts){
      fclts[f.id]={
        name: f.name,
        depts: f.department_set.map(x=>x.id),
        link: f.link
      }
    }

    for(let f of FcltDepts){ for (let d of f.department_set){
        depts[d.id]={
          name: d.name,
          short: d.short,
          facultyID: d.faculty,
          link: d.link
        }
    }}

    return {fclts, depts}
  }
)

export const fcltDeptsThunks = {fetchFcltDepts};

const fcltDeptsSlice_static = createSlice({
  name: 'fcltDepts_static',
  initialState,
  reducers: {
  },
  extraReducers: builder=>{
    builder.addCase(fetchFcltDepts.pending, (state, action) => {
        state.status = 'loading';
    });
    builder.addCase(fetchFcltDepts.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const {fclts, depts} = action.payload;
        state.fclts = fclts;
        state.depts = depts;
    });
    builder.addCase(fetchFcltDepts.rejected, (state, action) => {
        state.status = 'failed';
        state.errorMsg = action.error.message;
    });
  }
});

export default fcltDeptsSlice_static;